var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71209 7.02459C4.0782 6.65847 4.6718 6.65847 5.03791 7.02459L10 11.9867L14.9621 7.02459C15.3282 6.65847 15.9218 6.65847 16.2879 7.02459C16.654 7.3907 16.654 7.9843 16.2879 8.35041L10.6629 13.9754C10.2968 14.3415 9.7032 14.3415 9.33709 13.9754L3.71209 8.35041C3.34597 7.9843 3.34597 7.3907 3.71209 7.02459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableviewIcon);
export default __webpack_public_path__ + "static/media/tableview_icon.26c09a9351563d363b57aff2ad253333.svg";
export { ForwardRef as ReactComponent };